export default __webpack_public_path__ + "static/media/creditcard-tilted-trademark.22116cb5.svg";